import { render, staticRenderFns } from "./BookingStartHowToBook.vue?vue&type=template&id=32884ce3&scoped=true"
import script from "./BookingStartHowToBook.vue?vue&type=script&lang=ts"
export * from "./BookingStartHowToBook.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32884ce3",
  null
  
)

export default component.exports